// extracted by css-extract-rspack-plugin
export default {"variablesDialog":"VariablesDialog-module__variablesDialog__IciFg62","DialogOverflowWrapper":"VariablesDialog-module__DialogOverflowWrapper__lDOyIZw"};